
import TenantSettings from 'stores/tenant-settings'
import $chats from 'stores/chats'
import $tenants from 'stores/tenants'
import TenantFeed from './tenant-feed.vue'
import TenantAf   from './tenant-af.vue'
import TenantPs from './tenant-ps.vue'
import TenantGeneral from './tenant-general.vue'

export default {
  components: {
    TenantFeed, TenantAf, TenantPs, TenantGeneral
  },
  props: {
    tenant: {type: Object, required: true}
  },
  data() {
    return {
      tabs: [
        {value: 'general', title: 'General'},
        {value: 'feed', title: 'Feed'},
        {value: 'auto_follow', title: 'Auto Follow'},
        {value: 'preferred_sources', title: 'Preferred Sources'},
      ],
      active: 'general',
      loading: true,
      saving: false,
      saved_at: undefined,
      store: undefined,
    }
  },
  async mounted() {
    this.loading = true
    this.store = new TenantSettings(this.tenant.id)
    await this.store.load()
    this.loading = false
  },
  methods: {
    async onUpdate() {
      this.saving = true
      await this.store.save()
      await Promise.all([
        $chats.load(),
        $tenants.loadCaps(),
      ])
      this.saved_at = Date.now()
      this.saving = false
    }
  }
}
